import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const Modal = ({
  isOpen,
  onClose,
  title,
  content,
  actions,
  size = 'medium',
  hideHeaderDivider = false,
  panelClassName = '',
  contentClassName = '',
  titleClassName = '',
}) => {
  const theme = useSelector((state) => state.theme.theme);
  
  if (!isOpen) return null;

  const sizeClasses = {
    small: 'max-w-md',
    medium: 'max-w-2xl',
    large: 'max-w-4xl',
  };

  return (
    <div
      className="fixed top-0 right-0 left-0 bottom-0 z-50 flex justify-center items-center w-full max-h-full bg-black bg-opacity-50"
      tabIndex="-6"
      aria-hidden="true"
    >
      <div className={`relative p-4 w-full ${sizeClasses[size]} max-h-full`}>
        <div
          className={`relative bg-white rounded-xl dark:bg-[#182433] overflow-hidden border shadow-[0_5.25px_21.02px_rgba(0,0,0,0.8)] flex flex-col ${
            theme === 'light' ? 'border-[#D1E2F0]' : 'border-[#25384F]'
          } ${panelClassName}`}
        >
          <div
            className={`flex items-center justify-between px-3 py-3 ${
              hideHeaderDivider
                ? ''
                : `border-b ${theme === 'light' ? 'border-[#D1E2F0]' : 'border-[#25384F]'}`
            }`}
          >
            <h3
              className={`text-lg font-semibold ${theme === 'light' ? 'text-[#0A2342]' : 'text-[#FFFFFF]'} ${titleClassName}`}
            >
              {title}
            </h3>
            <button
              type="button"
              className={`${theme === 'light' ? 'text-[#0A2342]' : 'text-[#FFFFFF]'} bg-transparent hover:bg-gray-200 hover:text-[#0A2342] rounded-lg text-sm w-7 h-7 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white`}
              onClick={onClose}
            >
              <svg
                className="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
          </div>
          <div className={`flex-1 min-h-0 overflow-y-auto text-black dark:text-custom-gray max-h-[70vh] ${contentClassName}`}>
            {content}
          </div>
          {actions && (
            <div
              className={`flex items-center justify-end px-3 py-3 border-t shrink-0 ${
                theme === 'light' ? 'border-[#D1E2F0]' : 'border-[#25384F]'
              }`}
            >
              {actions}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  actions: PropTypes.node,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  hideHeaderDivider: PropTypes.bool,
  panelClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  titleClassName: PropTypes.string,
};

Modal.defaultProps = {
  size: 'medium',
  actions: null,
  hideHeaderDivider: false,
  panelClassName: '',
  contentClassName: '',
  titleClassName: '',
};

export default Modal;